import styled from "styled-components";
import { FaUsers, FaStar, FaMicrophoneAlt, FaFlask } from "react-icons/fa";

/* ─────────────────────────────────────────
   IMAGE SLOTS — replace null with require()
   e.g. require("../assets/images/tech-showcase/panel1-a.webp")
───────────────────────────────────────── */
const panel1Images = [require("../assets/images/summit/Scalablesolutions.webp")];
const panel2Images = [
  require("../assets/images/summit/panel21.webp"),
  require("../assets/images/summit/panel22.webp"),
];        // 2 images
const panel3Images = [require("../assets/images/summit/panel3.webp")];
const expertTalkImage = require("../assets/images/summit/profmohansankar.webp");

/* ─────────────────────────────────────────
   DATA
───────────────────────────────────────── */
const panels = [
  {
    number: "01",
    title: "Scalable Solutions for a Sustainable Future",
    theme: "Sustainability",
    members: [
      { name: "Mr. Himanshu Nivsarkar", designation: "Senior Executive Vice President & Head – CSR & ESG, Kotak Mahindra Bank" },
      { name: "Ms. Aloka Majumdar", designation: "Managing Director & Head of Sustainability, HSBC India" },
      { name: "Mr. Pushp Kumar Nayar", designation: "Executive Director – HR, BPCL" },
      { name: "Mr. Anuj Gupta", designation: "Managing Director – India, BowerGroupAsia" },
    ],
    moderator: { name: "Prof. Rajnish Kumar", designation: "Head, School of Sustainability & Professor, Department of Chemical Engineering, IIT Madras" },
    images: panel1Images,
    keynote: null,
    splitLayout: true,
  },
  {
    number: "02",
    title: "Building Bharat's Semiconductor Ecosystem: Design, Fabrication & Talent",
    theme: "Semiconductors",
    members: [
      { name: "Mr. Santosh Kumar", designation: "Managing Director, Texas Instruments India" },
      { name: "Mr. Anil Gupta", designation: "Executive Director, Lam India Global Hardware Technology (LIGHT), Lam Research India" },
      { name: "Mr. Sreenivas Subramoney", designation: "Senior Distinguished Engineer, GPU Architecture, NVIDIA Corporation" },
      { name: "Mr. Amandeep Punhani", designation: "Senior Director – R&D & Noida Site Head, NXP Semiconductors" },
    ],
    moderator: { name: "Prof. Sankaran Aniruddhan", designation: "Professor, Department of Electrical Engineering, IIT Madras" },
    images: panel2Images,
    twoColLayout: true,
    keynote: {
      speaker: "Shri S Krishnan, IAS",
      speakerRole: "Secretary, Ministry of Electronics and Information Technology (MeitY), Government of India",
      description:
        "India's evolving digital and semiconductor landscape, innovation ecosystem, and technology-driven growth opportunities.",
    },
  },
  {
    number: "03",
    title: "Startup Nation, Deep Tech Future: Building Scalable Innovation Ecosystems",
    theme: "Deep Tech & Startups",
    description:
      "A discussion on strengthening India's deep-tech and startup ecosystem through innovation, entrepreneurship, investment, industry partnerships, and scalable technology-driven growth.",
    members: [
      { name: "Mr. Rajiv Lochan", designation: "CEO & MD - Sundaram Finance" },
      { name: "Mr. Bhaskar Majumdar", designation: "Founder & Managing Partner, Unicorn India Ventures" },
      { name: "Mr. Shankar Vanavarayar", designation: "President – Kumaraguru Institutions & Executive Director – ABT Industries Ltd" },
    ],
    moderator: { name: "Prof. Satyanarayanan Seshadri", designation: "Head – School of Innovation & Entrepreneurship and Associate Professor, Department of Applied Mechanics & Biomedical Engineering, IIT Madras" },
    images: panel3Images,
    keynote: null,
    splitLayout: true,
  },
];

/* ─────────────────────────────────────────
   IMAGE SLOT COMPONENT
───────────────────────────────────────── */
const ImgSlot = ({ src, alt }) =>
  src ? (
    <SlotImg src={src} alt={alt} />
  ) : (
    <SlotPlaceholder>
      <SlotLabel>Image coming soon</SlotLabel>
    </SlotPlaceholder>
  );

/* ─────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────── */
const TechShowcase = () => {
  return (
    <Section id="tech-showcase">
      <SectionLabel>Summit Highlights</SectionLabel>
      <MainHeading>Technology Showcase</MainHeading>
      <Divider />
      <SubHeading>
        A showcase of innovative technologies and impactful solutions developed at IIT Madras,
        highlighting advancements in sustainability, healthcare, energy transition, robotics, AI,
        and scalable societal impact initiatives.
      </SubHeading>
      

      <Wrapper>
        {panels.map((panel, i) => (
          <PanelCard key={i}>

            {/* Card header */}
            <PanelHeader>
              <PanelNumber>
                <PanelWord>Panel</PanelWord>
                {panel.number}
              </PanelNumber>
              <PanelMeta>
                <ThemeBadge>{panel.theme}</ThemeBadge>
                <PanelTitle>{panel.title}</PanelTitle>
                {panel.description && (
                  <PanelDesc>{panel.description}</PanelDesc>
                )}
              </PanelMeta>
            </PanelHeader>

            {panel.twoColLayout ? (
              <TwoColBody>
                <TwoColLeft>
                  <TwoColInfo>
                    {panel.keynote && (
                      <KeynoteBox>
                        <KeynoteTag><FaMicrophoneAlt /> Keynote Address</KeynoteTag>
                        <KeynoteSpeaker>{panel.keynote.speaker}</KeynoteSpeaker>
                        {panel.keynote.speakerRole && <KeynoteSpeakerRole>{panel.keynote.speakerRole}</KeynoteSpeakerRole>}
                        <KeynoteDesc>{panel.keynote.description}</KeynoteDesc>
                      </KeynoteBox>
                    )}
                  </TwoColInfo>
                  <SmallImageWrap>
                    <SmallImageCard>
                      <ImgSlot src={panel.images[1]} alt={`${panel.title} image 2`} />
                    </SmallImageCard>
                  </SmallImageWrap>
                </TwoColLeft>
                <TwoColRight>
                  <TwoColInfo>
                    <InfoBlock>
                      <InfoHeading><FaUsers /> Panelist</InfoHeading>
                      <MemberList>
                        {panel.members.map((m, j) => (
                          <MemberItem key={j}>
                            {typeof m === "object" ? (
                              <>
                                <span>{m.name}</span>
                                {m.designation && <MemberDesignation>{m.designation}</MemberDesignation>}
                              </>
                            ) : m}
                          </MemberItem>
                        ))}
                      </MemberList>
                    </InfoBlock>
                    <ModeratorBox>
                      <ModLabel>Moderator</ModLabel>
                      <ModName>{typeof panel.moderator === "object" ? panel.moderator.name : panel.moderator}</ModName>
                      {typeof panel.moderator === "object" && panel.moderator.designation && (
                        <MemberDesignation>{panel.moderator.designation}</MemberDesignation>
                      )}
                    </ModeratorBox>
                  </TwoColInfo>
                  <SmallImageWrap>
                    <SmallImageCard>
                      <ImgSlot src={panel.images[0]} alt={`${panel.title} image 1`} />
                    </SmallImageCard>
                  </SmallImageWrap>
                </TwoColRight>
              </TwoColBody>
            ) : panel.imageLeftLayout ? (
              <ImageLeftBody>
                <ImageLeftCol>
                  <ImgSlot src={panel.images[0]} alt={`${panel.title} main`} />
                  {panel.images[1] && (
                    <OverlayInset src={panel.images[1]} alt={`${panel.title} inset`} />
                  )}
                </ImageLeftCol>
                <ImageRightCol>
                  {panel.keynote && (
                    <KeynoteBox>
                      <KeynoteTag>
                        <FaMicrophoneAlt /> Keynote Address
                      </KeynoteTag>
                      <KeynoteSpeaker>{panel.keynote.speaker}</KeynoteSpeaker>
                      <KeynoteDesc>{panel.keynote.description}</KeynoteDesc>
                    </KeynoteBox>
                  )}
                  <InfoBlock>
                    <InfoHeading><FaUsers /> Panelist</InfoHeading>
                    <MemberList>
                      {panel.members.map((m, j) => (
                        <MemberItem key={j}>{m}</MemberItem>
                      ))}
                    </MemberList>
                  </InfoBlock>
                  <ModeratorBox>
                    <ModLabel>Moderator</ModLabel>
                    <ModName>{panel.moderator}</ModName>
                  </ModeratorBox>
                </ImageRightCol>
              </ImageLeftBody>
            ) : panel.splitLayout ? (
              <SplitBody>
                <SplitLeft>
                  <InfoBlock>
                    <InfoHeading><FaUsers /> Panelist</InfoHeading>
                    <MemberList>
                      {panel.members.map((m, j) => (
                        <MemberItem key={j}>
                          {typeof m === "object" ? (
                            <>
                              <span>{m.name}</span>
                              {m.designation && <MemberDesignation>{m.designation}</MemberDesignation>}
                            </>
                          ) : m}
                        </MemberItem>
                      ))}
                    </MemberList>
                  </InfoBlock>
                  <ModeratorBox>
                    <ModLabel>Moderator</ModLabel>
                    <ModName>{typeof panel.moderator === "object" ? panel.moderator.name : panel.moderator}</ModName>
                    {typeof panel.moderator === "object" && panel.moderator.designation && (
                      <MemberDesignation>{panel.moderator.designation}</MemberDesignation>
                    )}
                  </ModeratorBox>
                </SplitLeft>
                <SplitRight>
                  {panel.images.map((src, j) => (
                    <ImgSlot key={j} src={src} alt={`${panel.title} image ${j + 1}`} />
                  ))}
                </SplitRight>
              </SplitBody>
            ) : (
              <>
                <PanelBody>
                  {panel.keynote && (
                    <KeynoteBox>
                      <KeynoteTag>
                        <FaMicrophoneAlt /> Keynote Address
                      </KeynoteTag>
                      <KeynoteSpeaker>{panel.keynote.speaker}</KeynoteSpeaker>
                      <KeynoteDesc>{panel.keynote.description}</KeynoteDesc>
                    </KeynoteBox>
                  )}
                  <PanelInfoRow>
                    <InfoBlock>
                      <InfoHeading><FaUsers /> Panelist</InfoHeading>
                      <MemberList>
                        {panel.members.map((m, j) => (
                          <MemberItem key={j}>{m}</MemberItem>
                        ))}
                      </MemberList>
                    </InfoBlock>
                    <ModeratorBox>
                      <ModLabel>Moderator</ModLabel>
                      <ModName>{panel.moderator}</ModName>
                    </ModeratorBox>
                  </PanelInfoRow>
                </PanelBody>
                {panel.overlayImages ? (
                  <OverlayImageBox>
                    <ImgSlot src={panel.images[0]} alt={`${panel.title} main`} />
                    {panel.images[1] && (
                      <OverlayInset src={panel.images[1]} alt={`${panel.title} inset`} />
                    )}
                  </OverlayImageBox>
                ) : (
                  <PanelImageRow count={panel.images.length}>
                    {panel.images.map((src, j) => (
                      <ImgSlot key={j} src={src} alt={`${panel.title} image ${j + 1}`} />
                    ))}
                  </PanelImageRow>
                )}
              </>
            )}
          </PanelCard>
        ))}

        {/* ── Expert Talk ── */}
        <ExpertCard>
          <ExpertRight>
            {expertTalkImage ? (
              <ExpertSlotImg src={expertTalkImage} alt="Prof. S. Mohanasankar" />
            ) : (
              <SlotPlaceholder style={{ height: "100%" }}>
                <SlotLabel>Image coming soon</SlotLabel>
              </SlotPlaceholder>
            )}
          </ExpertRight>

          <ExpertLeft>
            <ExpertTag>
              <FaFlask /> Expert Talk on Healthcare
            </ExpertTag>
            <ExpertName>Prof. S. Mohanasankar</ExpertName>
            <ExpertRole>
              Head - Sudha Gopalakrishnan Brain Centre and Healthcare Technology Innovation Centre
            </ExpertRole>
            <ExpertDept>Professor, Dept. of Electrical Engineering · IIT Madras</ExpertDept>
          </ExpertLeft>
        </ExpertCard>

      </Wrapper>
    </Section>
  );
};

export default TechShowcase;


/* ═══════════════════════════════════════
   STYLES
═══════════════════════════════════════ */

const Section = styled.section`
  padding: 20px 20px;
  background: #ffffff;

  @media (max-width: 768px) {
    padding: 36px 14px;
  }
`;

const SectionLabel = styled.p`
  text-align: center;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #d6a54f;
  margin-bottom: 10px;
`;

const MainHeading = styled.h2`
  text-align: center;
  font-size: 38px;
  font-weight: 700;
  color: #791e1b;
  margin: 0 0 14px;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const SubHeading = styled.p`
  text-align: center;
  max-width: 820px;
  margin: 0 auto 20px;
  font-size: 15px;
  line-height: 1.8;
  color: #4b5563;
`;

const Divider = styled.div`
  width: 60px;
  height: 4px;
  background: #d6a54f;
  border-radius: 2px;
  margin: 0 auto 22px;
`;

const Wrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

/* ── Panel card ── */

const PanelCard = styled.div`
  background: #faf8f5;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 22px rgba(0, 0, 0, 0.07);
  border: 1px solid #f0ebe3;
`;

const PanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 28px 32px 20px;
  border-bottom: 1px solid #ede8e0;
  background: #fff;

  @media (max-width: 768px) {
    padding: 20px 18px 16px;
    gap: 14px;
  }
`;

const PanelNumber = styled.span`
  font-size: 52px;
  font-weight: 900;
  color: #ede0cc;
  line-height: 1;
  flex-shrink: 0;
  margin-top: -4px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    font-size: 34px;
  }
`;

const PanelWord = styled.span`
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #c4a882;
  line-height: 1;
  margin-bottom: 2px;
`;

const PanelMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const ThemeBadge = styled.span`
  display: inline-block;
  background: #f9e8e8;
  color: #791e1b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 3px 12px;
  border-radius: 20px;
  align-self: flex-start;
`;

const PanelTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #171f32;
  margin: 0;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const PanelDesc = styled.p`
  font-size: 14px;
  color: #6b7280;
  line-height: 1.7;
  margin: 0;
`;

const PanelBody = styled.div`
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-bottom: 1px solid #ede8e0;

  @media (max-width: 768px) {
    padding: 20px 18px;
  }
`;

const PanelInfoRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 24px;
  align-items: start;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

/* ── Split layout (info left, images right) ── */

const SplitBody = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 300px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const SplitLeft = styled.div`
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  border-right: 1px solid #ede8e0;

  @media (max-width: 768px) {
    padding: 20px 18px;
    border-right: none;
    border-bottom: 1px solid #ede8e0;
  }
`;

const SplitRight = styled.div`
  display: grid;
  grid-template-columns: ${(p) => (p.children?.length === 2 ? "1fr 1fr" : "1fr")};
  overflow: hidden;
`;

/* ── Panel images — full width below info ── */

const PanelImageRow = styled.div`
  display: grid;
  grid-template-columns: ${(p) => (p.stack || p.count !== 2 ? "1fr" : "1fr 1fr")};
  grid-template-rows: ${(p) => (p.stack && p.count === 2 ? "1fr 1fr" : "auto")};
  min-height: 260px;
  border-top: 1px solid #ede8e0;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    min-height: auto;
  }
`;

/* ── Two-column layout ── */

const TwoColBody = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const TwoColLeft = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 1px solid #ede8e0;

  @media (max-width: 768px) {
    border-right: none;
    border-bottom: 1px solid #ede8e0;
  }
`;

const TwoColRight = styled.div`
  display: flex;
  flex-direction: column;
`;

const TwoColInfo = styled.div`
  padding: 28px 32px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 768px) {
    padding: 20px 18px;
  }
`;

const SmallImageWrap = styled.div`
  padding: 0 32px 24px;

  @media (max-width: 768px) {
    padding: 0 18px 20px;
  }
`;

const SmallImageCard = styled.div`
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid #ede8e0;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
  }
`;

const TwoColImage = styled.div`
  flex: 1;
  width: 100%;
  min-height: 160px;
  max-height: 200px;
  overflow: hidden;
`;

/* ── Image-left layout ── */

const ImageLeftBody = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 340px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ImageLeftCol = styled.div`
  position: relative;
  overflow: hidden;
`;

const ImageRightCol = styled.div`
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  border-left: 1px solid #ede8e0;
  background: #fff;

  @media (max-width: 768px) {
    padding: 20px 18px;
    border-left: none;
    border-top: 1px solid #ede8e0;
  }
`;

const OverlayImageBox = styled.div`
  position: relative;
  overflow: hidden;
  min-height: 300px;
  border-top: 1px solid #ede8e0;
`;

const OverlayInset = styled.img`
  position: absolute;
  top: 16px;
  left: 16px;
  width: 200px;
  height: 140px;
  object-fit: cover;
  border-radius: 10px;
  border: 3px solid #fff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: zoom-in;

  &:hover {
    transform: scale(1.5);
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.5);
    z-index: 10;
  }

  @media (max-width: 640px) {
    width: 130px;
    height: 90px;
  }
`;

const KeynoteBox = styled.div`
  background: #171f32;
  border-radius: 12px;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const KeynoteTag = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #d6a54f;
`;

const KeynoteSpeaker = styled.span`
  font-size: 17px;
  font-weight: 700;
  color: #fff;
`;

const KeynoteSpeakerRole = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #d6a54f;
  line-height: 1.4;
`;

const KeynoteDesc = styled.p`
  font-size: 13px;
  color: #9ca3af;
  line-height: 1.6;
  margin: 0;
`;

const InfoBlock = styled.div``;

const InfoHeading = styled.p`
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #791e1b;
  margin-bottom: 12px;
`;

const MemberList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const MemberItem = styled.li`
  font-size: 15px;
  font-weight: 600;
  color: #171f32;
  padding-left: 14px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 7px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #d6a54f;
  }
`;

const MemberDesignation = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: #6b7280;
  line-height: 1.4;
  margin-top: 2px;
`;

const ModeratorBox = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 14px 18px;
  border-left: 3px solid #791e1b;
`;

const ModLabel = styled.p`
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #791e1b;
  margin-bottom: 4px;
`;

const ModName = styled.p`
  font-size: 15px;
  font-weight: 700;
  color: #171f32;
  margin: 0;
`;


const SlotImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  display: block;
`;

const ExpertSlotImg = styled.img`
  width: 100%;
  height: 300px;
  object-fit: cover;
  object-position: center 55%;
  display: block;
`;

const SlotPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: repeating-linear-gradient(
    135deg,
    #f5f0e8 0px,
    #f5f0e8 18px,
    #ede8e0 18px,
    #ede8e0 36px
  );
  min-height: 120px;
`;

const SlotLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #b09060;
  letter-spacing: 1px;
  background: rgba(255, 255, 255, 0.7);
  padding: 6px 14px;
  border-radius: 20px;
`;

/* ── Expert Talk card ── */

const ExpertCard = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 22px rgba(0, 0, 0, 0.1);
  background: #171f32;
  min-height: 240px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ExpertLeft = styled.div`
  padding: 36px 32px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 24px 20px;
  }
`;

const ExpertTag = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #d6a54f;
`;

const ExpertName = styled.h3`
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const ExpertRole = styled.p`
  font-size: 14px;
  color: #d1d5db;
  line-height: 1.6;
  margin: 0;
`;

const ExpertDept = styled.p`
  font-size: 13px;
  font-weight: 600;
  color: #d6a54f;
  margin: 0;
`;

const ExpertRight = styled.div`
  overflow: hidden;
  min-height: 240px;

  ${SlotPlaceholder} {
    height: 100%;
    background: repeating-linear-gradient(
      135deg,
      #1e2740 0px,
      #1e2740 18px,
      #171f32 18px,
      #171f32 36px
    );

    ${SlotLabel} {
      color: #d6a54f;
      background: rgba(0, 0, 0, 0.4);
    }
  }
`;
